module.exports = __webpack_public_path__ + "img/hr-green-carpet-grass-01.544b5426.png";